module.exports = __webpack_public_path__ + "img/G1.db27e359.jpg";